import { useEffect, useMemo, useState } from 'react';
import { useFormikContext } from 'formik';
import { DialogActions, DialogContent, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { PriorityHighRounded } from '@mui/icons-material';
import { Modal } from '@shared/components/modals/Modal';
import { SaveButton } from '@shared/inputs/Buttons';

import { extractErrorMessages } from '../components/Assets/utils';

export const UnableToSaveModal = () => {
    const [open, isOpen] = useState(false);
    const { errors, isValid, isValidating, isSubmitting } = useFormikContext();    
    useEffect(() => {
        if (!isValid && !isValidating && isSubmitting) {
            isOpen(true);
        }
    }, [isSubmitting, isValid, isValidating]); 
      
    const errorMessages = useMemo(() => extractErrorMessages(errors), [errors]);
      
    return (
        <Modal
            open={open}
            title="Unable to Save"
            dialogWidth="500px"
            onClose={() => isOpen(false)}
        >
            <DialogContent>
                <Typography>
                    The following fields have either missing or incorrect information preventing save. Please update and try again.
                </Typography>
                <List>
                    {errorMessages.map((error, index) => (
                        <ListItem key={error + index}>
                            <ListItemIcon>
                                <PriorityHighRounded sx={{color: 'red', fontSize: '2rem'}}/>
                            </ListItemIcon>
                            <ListItemText primary={`${error}`} />
                        </ListItem>
                    ))}
                </List>
                <DialogActions>
                    <SaveButton label='Okay' onClick={() => isOpen(false)} />
                </DialogActions>
            </DialogContent>
        </Modal>
      );
};